<template>
  <div>
    <can action="view" subject="timeslots">
      <div class="ibox">
        <div class="ibox-title">
          <h5>Timeslots</h5>
          <div class="ibox-tools">
            <can action="edit" subject="timeslots">
              <el-tooltip class="item" content="Add timeslot" placement="left">
                <el-button
                  type="primary"
                  size="small"
                  class="ibox-tool-btn"
                  @click="editTimeslot(null)"
                  plain
                >
                  <i class="fa fa-plus"></i>
                </el-button>
              </el-tooltip>
            </can>
          </div>
        </div>
        <div
          class="ibox-content ibox-heading"
        >On which days and at what times do our various radio shows commence?</div>
        <div class="ibox-content timeslot-list-content">
          <el-table
            stripe
            row-key="id"
            max-height="400"
            style="width: 100%"
            width="100%"
            :show-timeout="150"
            :data="timeslots"
            :fit="true"
            :default-sort="{prop: 'title'}"
          >
            <el-table-column type="index" label="#" width="60" />

            <el-table-column prop="title" label="Title" :class-name="'client-link'">
              <template slot-scope="scope">
                <el-tooltip class="item" content="Edit" placement="right">
                  <a @click="editTimeslot(scope.row.id)">{{scope.row.title}}</a>
                </el-tooltip>
              </template>
            </el-table-column>

            <!-- <el-table-column :formatter="daysAndTimes" label="Slot" width="220" /> -->
            <el-table-column :formatter="days" label="Days" width="120" />
            <el-table-column :formatter="times" label="Times" width="120" />

            <el-table-column prop="color" label="Color" width="80">
              <template slot-scope="scope">
                <div type="danger" :style="getCellStyle(scope.row)">&nbsp;</div>
              </template>
            </el-table-column>

            <el-table-column label width="160">
              <template slot-scope="scope">
                <el-dropdown trigger="hover" placement="bottom" @command="handleTimeslotAction">
                  <span class="el-dropdown-link">
                    Actions
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{action: editTimeslot, item: scope.row.id}">Edit</el-dropdown-item>
                    <el-dropdown-item :command="{action: deleteTimeslot, item: scope.row.id}">Delete</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </can>
    <el-dialog
      :title="this.isNewTimeslot ? 'New Timeslot' : 'Edit Timeslot'"
      :visible.sync="showEditDialog"
      :close-on-click-modal="false"
    >
      <timeslot-edit
        v-if="showEditDialog"
        :weekdays="weekdays"
        :is-new="isNewTimeslot"
        @cancel="showEditDialog = false"
        @save="saveTimeslot"
      ></timeslot-edit>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Can from '@/components/permissions/Can';
import TimeslotEdit from './TimeslotEdit';

import * as types from '../../store/modules/timeslots/mutation-types';

const trimLast = (str, char = ':') => str.slice(0, str.lastIndexOf(char));

export default {
  name: 'TimeslotsList',
  props: ['timeslots'],
  components: { TimeslotEdit, Can },

  data() {
    return {
      weekdays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      showEditDialog: false,
      selectedTimeslot: null,
      isNewTimeslot: false,
    };
  },

  computed: {
    ...mapState('timeslots', ['saveTimeslotRequest', 'saveTimeslotSuccess']),
  },

  methods: {
    days(row) {
      return [this.weekdays[row.start_day], this.weekdays[row.end_day]] // day range
        .map(x => x.slice(0, 3)) // shorten to 3 chars
        .join(' to '); // Mon to Fri
    },

    times(row) {
      return `${trimLast(row.start_time)} - ${trimLast(row.end_time)}`;
    },

    daysAndTimes(row) {
      return `${this.days(row)}, ${this.times(row)}`;
    },

    getCellStyle(row) {
      return {
        'background-color': row.colour,
      };
    },

    editTimeslot(id) {
      this.isNewTimeslot = id === null;
      this.selectedTimeslot = this.timeslots.find(x => x.id === id);
      this.showEditDialog = true;
      this.$store.commit(`timeslots/${types.EDIT_TIMESLOT}`, this.selectedTimeslot);
    },

    saveTimeslot(slot) {
      this.$store.dispatch(`timeslots/${this.isNewTimeslot ? 'create' : 'update'}Timeslot`, slot);
    },

    deleteTimeslot(id) {
      this.$confirm('Are you sure you want to remove this Timeslot?')
        .then(() => {
          this.$store.dispatch('timeslots/deleteTimeslot', id);
        })
        .catch(() => null); // prevent uncaught exeptions warning in console...
    },

    handleTimeslotAction(command) {
      /**
       * Executes the action by passing the item as parameter.
       *
       * @param {command}: object with actions and item properties
       */
      command.action(command.item);
    },
  },

  watch: {
    saveTimeslotRequest(val, oldVal) {
      if (val === oldVal) return;

      if (!val && this.saveTimeslotSuccess) {
        this.showEditDialog = false;
        this.$notify({
          type: 'success',
          title: 'Success',
          message: 'Timeslot saved successfully',
        });
      }

      if (!val && !this.saveTimeslotSuccess) {
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Unable to save timeslot. Please confirm all fields and try again.',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.timeslot-list-content {
  padding: 8px;
}

.ibox-tool-btn {
  margin-top: -10px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// TimeslotList.vue?6e645202